import fetch from "./fetch-trade-api";

export const sendCode = async ({ phone, email }) => {
  const resp = phone
    ? await fetch(`/v1/report/verify/sms/${phone}`, { method: "POST" })
    : await fetch(`/v1/report/verify/email/${email}`, { method: "POST" });
  return resp.text();
};

export const verifyCode = async ({ guid, code = "" }) => {
  const resp = await fetch(
    `/v1/report/verify/validate/${guid}/${code.toUpperCase()}`
  );
  return (await resp.text()) === "true";
};
